import type { ListingCardData } from '@/stores/search';

/**
 * Where an advertisement says it is, as one line: the suburb (or the region, for an account that
 * named only one) and the state. The Gallery tile and the viewer opened from it print the same
 * plate, so they print the same words.
 */
export function listingPlace(listing: ListingCardData): string {
  return [listing.city ?? listing.region, listing.state].filter(Boolean).join(', ') || 'Australia';
}

/** The plate's right-hand line: where, then how old. The age is simply absent when withheld. */
export function listingWhereAge(listing: ListingCardData): string {
  return `${listingPlace(listing)}${listing.age != null ? ` · ${listing.age}yo` : ''}`;
}
